import { render, staticRenderFns } from "./BrandProfile.vue?vue&type=template&id=406635d4&scoped=true&"
import script from "./BrandProfile.vue?vue&type=script&lang=js&"
export * from "./BrandProfile.vue?vue&type=script&lang=js&"
import style0 from "./BrandProfile.vue?vue&type=style&index=0&id=406635d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406635d4",
  null
  
)

export default component.exports